interface HeatMeterProps {
  value: number;
  max: number;
  className?: string;
}

export default function HeatMeter({ value, max, className = "" }: HeatMeterProps) {
  const percent = Math.max(6, Math.round((value / max) * 100));
  return (
    <div className={`h-1.5 w-full overflow-hidden rounded-full bg-background-200 ${className}`}>
      <div
        className="h-full rounded-full bg-gradient-to-r from-accent-500 to-primary-500 transition-all duration-500"
        style={{ width: `${percent}%` }}
      />
    </div>
  );
}